import { createAction } from '@reduxjs/toolkit';

export const UPDATE_MESSAGE_CARD_VIDEO_ACTION_TYPE = 'saga/updateMessageCardVideo';
export const updateMessageCardVideoAction = createAction(UPDATE_MESSAGE_CARD_VIDEO_ACTION_TYPE);
